export const barChartOptions = {
  series: [
    {
      type: 'bar',
    },
  ],
};
